import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../RootState';

export const selectUi = (s: RootState) => s.ui;
export const selectDialog = (s: RootState) => s.ui.dialog;
export const selectToasts = (s: RootState) => s.ui.toasts;

/** Вибрані записи типу (масові дії). */
export const selectSelection = (recordType: string) =>
  createSelector([(s: RootState) => s.ui.selection], (selection) => selection[recordType] ?? []);
